import React, { useMemo, useEffect, useState } from 'react';

import { useMytaverse } from '@providers/MytaverseProvider';
import { shouldShowFeedbackForEvent } from '@core/dashboard/utils/feedbackFormUtils';
import ConfirmLogoutModalView from './ConfirmLogoutModalView';
import { useLogout } from '@components/ConfirmLogoutModal/hooks';

import { IConfirmLogoutModal } from './interfaces';

const ConfirmLogoutModal = ({
  open,
  onClose,
  onConfirm,
  altStyling = false,
}: IConfirmLogoutModal) => {
  const { setShowFeedbackForm, user } = useMytaverse();

  const [localEventTags, setLocalEventTags] = useState<string[] | undefined>(
    undefined,
  );

  const handleExitButtonClick = useLogout({ onConfirm, onClose });

  useEffect(() => {
    const updateEventTags = () => {
      try {
        const storedTags = localStorage.getItem('currentEventTags');
        if (storedTags) {
          const parsedTags = JSON.parse(storedTags);
          setLocalEventTags(parsedTags);
        } else {
          setLocalEventTags(undefined);
        }
      } catch (error) {
        setLocalEventTags(undefined);
      }
    };

    updateEventTags();

    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'currentEventTags') {
        updateEventTags();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const isInDashboard = !!localEventTags;

  const feedbackCompleted = useMemo(() => user.feedbackCompleted, [user]);

  const shouldShowFeedback = useMemo(() => {
    if (feedbackCompleted) return false;

    if (isInDashboard && localEventTags) {
      return shouldShowFeedbackForEvent(localEventTags);
    }

    return false;
  }, [feedbackCompleted, localEventTags, isInDashboard]);

  const handleAltCancelAction = () => {
    setShowFeedbackForm(true);
  };

  return (
    <ConfirmLogoutModalView
      open={open}
      onClose={onClose}
      onExitButtonClick={handleExitButtonClick}
      altStyling={altStyling}
      showFeedback={shouldShowFeedback}
      onCancelAltAction={shouldShowFeedback ? handleAltCancelAction : null}
    />
  );
};

export default ConfirmLogoutModal;
